import styled, { css } from 'styled-components';
import {
  RichTextPartial,
  TypographyStyles,
  WhiteButton,
  colours,
  maxWidthPartial,
  media,
  spacing,
} from '@storefront/lib-global';

export const StoreDetailSection = styled.section`
  margin-top: ${spacing.M};
`;

export const LocatorContent = styled.div`
  display: flex;
  flex-direction: column;

  @media ${media.greaterThan('lg')} {
    ${maxWidthPartial({ withPaddingXL: true })}
    flex-direction: row;
    gap: 80px;
  }
`;

export const StoreDetailWrapper = styled.div<{ $isStar2?: boolean }>`
  ${({ $isStar2 }) =>
    !$isStar2
      ? css`
          flex: 0 1 332px;
        `
      : null}
  background-color: ${colours.LIGHT_GREY_2};
  display: flex;
  flex-direction: column;
  gap: ${spacing.XS};
  padding: 20px ${spacing.S};

  @media ${media.greaterThan('lg')} {
    background-color: unset;
    gap: ${spacing.S};
    padding: 0;
  }
`;

export const StoreCardMap = styled.div`
  @media ${media.greaterThan('lg')} {
    margin-bottom: ${spacing.L};
  }
`;

export const StoreCardMapContent = styled.div`
  display: block;

  @media ${media.greaterThan('lg')} {
    flex: 0 1 888px;
  }
`;

export const StoreLocatorContentBodyText = styled(RichTextPartial)`
  padding: 0 ${spacing.S};

  @media ${media.greaterThan('lg')} {
    padding: 0;
  }
`;

export const SlotContent = styled.div`
  margin: ${spacing.M} 0;

  @media ${media.greaterThan('lg')} {
    margin: 80px 0;
  }
`;

export const Back = styled.div`
  ${TypographyStyles.CallToAction.Large.SemiBold}
  align-items: center;
  display: flex;
  gap: ${spacing.XXXXS};
  height: 28px;
  text-decoration: underline;

  > a {
    color: ${colours.BLACK};
  }
`;

export const StoreName = styled.h1`
  ${TypographyStyles.Headings.H3}
  margin: 0;
  text-transform: uppercase;
`;

export const StoreDetail = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.XXXXS};

  > span {
    ${TypographyStyles.Body.Small.SemiBold}
  }

  > ul {
    list-style-type: none;
    margin: 0;
    padding: 0;

    > li {
      ${TypographyStyles.Body.Small.Regular}
      padding-left: 25px;
      position: relative;
    }

    > li:before {
      background-color: ${colours.BLACK};
      border-radius: 50%;
      content: '';
      height: 2.5px;
      left: 11px;
      position: absolute;
      top: 13px;
      width: 2.5px;
    }
  }
`;

export const StoreDetailContent = styled.div`
  > p {
    ${TypographyStyles.Body.Small.Regular}
    margin: 0;
  }
`;

export const DepartmentLink = styled.a`
  ${TypographyStyles.Body.Small.SemiBold}
  color: ${colours.BLACK};
`;

export const StoreDetailButton = styled.button`
  ${TypographyStyles.CallToAction.Large.SemiBold}
  align-items: center;
  background-color: unset;
  border: none;
  color: ${colours.BLACK};
  cursor: pointer;
  display: flex;
  margin: 0;
  padding: 0;
  text-decoration: underline;
`;

export const BookFittingCta = styled(WhiteButton)`
  height: 50px;

  &:not([disabled]):hover,
  &:not([disabled]):focus {
    background-color: ${colours.LIGHT_BLUE};
  }
`;

export const StoreLocatorDetailHours = styled.span`
  display: flex;
`;
